export default {
  title: 'Production Batches',
  addBatch: 'Add Batch',
  batchInfo: 'Batch Info',
  batchInfoPlaceholder: 'Enter batch ID or batch name',
  productInfo: 'Product Info',
  productInfoPlaceholder: 'Enter product name',
  productNoLabel: 'Product No.: ',
  id: 'ID',
  batchName: 'Batch Name',
  createTime: 'Created At',
  batchNameLabel: 'Batch Name',
  batchNamePlaceholder: 'Enter batch name',
  batchNameRequired: 'Please enter batch name',
  batchNameMax: 'Max 30 characters',
  relatedProduct: 'Related Product',
  selectSku: 'Select SKU',
  skuPlaceholder: 'SKU',
  productionDate: 'Production Date',
  productionDatePlaceholder: 'Select production date',
  productionDateRequired: 'Please select production date',
  shelfLife: 'Shelf Life',
  shelfLifeRequired: 'Please select shelf life type',
  validityMode: 'Validity Mode',
  validityModeRequired: 'Please select validity mode',
  validityModePlaceholder: 'Select validity mode',
  validityNum: 'Validity Period',
  validityNumRequired: 'Please enter validity period',
  validDays: 'Valid Days',
  validMonths: 'Valid Months',
  validDate: 'Valid Until',
  validityYears: 'Valid Years',
  validityLongTerm: 'Long-term Valid',
  longTerm: 'Long-term',
  validDaysPlaceholder: 'Enter valid days',
  validDaysRequired: 'Please enter valid days',
  validMonthsPlaceholder: 'Enter valid months',
  validMonthsRequired: 'Please enter valid months',
  validDatePlaceholder: 'Select valid date',
  validDateRequired: 'Please select valid date',
  validityYearsPlaceholder: 'Enter valid years',
  relatedProductRequired: 'Please select a product',
  remark: 'Remark',
  remarkPlaceholder: 'Enter remark',
  factory: 'Factory',
  inspectionReport: 'Inspection Report',
  inspectionReportTip: 'Upload inspection report image',
  selectProductTitle: 'Select Product',
  productName: 'Product Name',
  productNamePlaceholder: 'Enter product name',
  spec: 'Spec',
  category: 'Category',
  retailPrice: 'Retail Price',
  select: 'Select',
};
